import EnumSet from 'Services/enumSet'

interface IPaymentTypes extends EnumSet {
  creditCard: number
  boleto: number
  pix: number
}

const paymentTypes = new EnumSet({
  creditCard: { value: 1, description: 'Cartão de crédito' },
  boleto: { value: 2, description: 'Boleto bancário' },
  pix: { value: 4, description: 'Pix' },

}) as IPaymentTypes

export default paymentTypes